import axios from 'axios';
const API_URL = process.env.REACT_APP_API;

export async function getDevolucion(filters: any) {
  const params = new URLSearchParams();

  if (filters.init_date) params.set('init_date', filters.init_date);
  if (filters.end_date) params.set('end_date', filters.end_date);

  const queryString = params.toString();
  const url = `${API_URL}catalogos/package-movement/return${
    queryString ? `?${queryString}` : ''
  }`;

  const response = await axios.get(url);
  const data = response.data.doc.data;
  return data;
}

export async function createDevolucion(body: any) {
  const { zone, razon, description, stock } = body;

  const response = await axios.post(
    `${API_URL}catalogos/package-movement/return`,
    {
      zona_id: Number(zone),
      motive_id: Number(razon),
      detail: description,
      iccids: stock,
    }
  );
  return response;
}

export async function getSelectRazon() {
  const response = await axios.get(`${API_URL}catalogos/motive/DEV`);
  const data = response.data.doc.data;
  let dataSelect: any = data;
  dataSelect.forEach((row: any) => {
    row.label = row.name;
    row.value = row.id;
  });
  return dataSelect;
}

export async function getPackageListById(id: number) {
  const response = await axios.get(`${API_URL}catalogos/stock/zone/${id}`);
  const data = response.data.doc.data.stocks;
  let dataSelect: any = data;
  dataSelect.forEach((row: any, index: number) => {
    row.count = index + 1;
    row.id = row.id;
    row.iccid = row.iccid;
    row.numero = row.msisdn;
    row.ubicacion = row.location;
  });
  return dataSelect;
}

export async function iccidValidation(iccid: string, zone_id: number) {
  const response = await axios.get(
    `${API_URL}catalogos/package-movement/return/validate/${iccid}/${zone_id}`
  );
  const data = response.data.doc.data;
  return data;
}

export async function downloadDevolucionReportPDF(id: number) {
  const date = new Date().toISOString().split('T')[0];

  try {
    const response = await axios({
      url: `${API_URL}reports/package/${id}/document/return/pdf`,
      method: 'GET',
      responseType: 'blob',
    });

    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `REPORTE-DEVOLUCION-${id}-${date}.pdf`);
    document.body.appendChild(link);
    link.click();
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 0);
  } catch (error: any) {
    const parsed = await error.response.data.text();
    return JSON.parse(parsed);
  }
}
